export const ALL_REVIEW_PROFILE = "all";

export const REVIEW_PROFILE_CODES = Object.freeze([
    "standard",
    "entrepreneur_smb",
    "legal_professional",
    "saas_ai_tech",
]);

export const isSystemCriterionForReviewProfiles = (criterion) => (
    criterion?.visibility_scope === "SYSTEM"
    || criterion?.client_id === null
    || criterion?.client_id === undefined
);

export const getCriterionReviewProfiles = (criterion) => (
    Array.isArray(criterion?.review_profiles)
        ? criterion.review_profiles.filter((value) => REVIEW_PROFILE_CODES.includes(value))
        : []
);

export const isCriterionVisibleForReviewProfile = (criterion, activeProfile) => {
    if (activeProfile === ALL_REVIEW_PROFILE) return true;
    const profiles = getCriterionReviewProfiles(criterion);
    return profiles.length === 0 || profiles.includes(activeProfile);
};

export const getDefaultReviewProfileForAudienceProfile = (audienceProfile) => {
    switch (audienceProfile) {
        case "legal_professional":
            return "legal_professional";
        case "entrepreneur_executive":
        case "sme_operations":
            return "entrepreneur_smb";
        default:
            return ALL_REVIEW_PROFILE;
    }
};

export const getReviewProfileLabel = (t, code, { short = false } = {}) => (
    t(`reviewProfiles.${short ? "optionsShort" : "options"}.${code}`)
);

export const getReviewProfileDescription = (t, code) => (
    t(`reviewProfiles.descriptions.${code}`)
);

export const buildReviewProfileOptions = (t, { includeAll = false, includeDescriptions = false } = {}) => {
    const toOption = (code) => ({
        value: code,
        label: getReviewProfileLabel(t, code),
        shortLabel: getReviewProfileLabel(t, code, { short: true }),
        ...(includeDescriptions ? { description: getReviewProfileDescription(t, code) } : {}),
    });

    const options = REVIEW_PROFILE_CODES.map(toOption);

    if (!includeAll) return options;

    return [
        toOption(ALL_REVIEW_PROFILE),
        ...options,
    ];
};
